// src/components/MessageInput.tsx
import React, { useState, useRef, useEffect } from 'react'

type Props = {
  onSend: (text: string) => void
  canSend: boolean    // allow or disable the input
  initComplete: boolean
  quotaUsageErrorMsg: string
}

const MessageInput = ({ onSend, canSend, initComplete, quotaUsageErrorMsg }: Props) => {
  const [text, setText] = useState('')
  const inputRef = useRef<HTMLTextAreaElement>(null)

   useEffect(() => {
     if (initComplete && inputRef.current) {
       inputRef.current.focus()
       // optional: place cursor at end of any pre-filled text
       inputRef.current.selectionStart = inputRef.current.selectionEnd = inputRef.current.value.length
     }
   }, [initComplete])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (text.trim() === '' || !canSend) return
    onSend(text)
    setText('')
  }

  const autoResize = (textarea: HTMLTextAreaElement) => {
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight - 100}px`
  }

  return (
    <form onSubmit={handleSubmit} className={`tt-input-container ${quotaUsageErrorMsg ? 'error flex-col': ''}`}>
      
      { !initComplete ? 
        <>
          <span className="tt-input-field waiting-ref">Please Wait... Initializing...</span>
          <button
            className="tt-send-button"
            type="submit"
            disabled={!canSend}
          >
            <span className="loader" /> 
          </button>
        </>
        :
        <>
          <div className='flex w-full align-center'>
          <textarea
            ref={inputRef}
            className="tt-input-field"
            value={text}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                handleSubmit(e)
              }
            }}
            onChange={(e) => {
              setText(e.target.value)
              autoResize(e.target)
            }}
            placeholder="Type your question here"
            readOnly={!canSend}
            rows={1}
          />

          <button
            className="tt-send-button"
            type="submit"
            disabled={!canSend}
          >
            {!canSend ? (
              <span className="loader" />
            ) : (
              <svg
                className="tt-send-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="currentColor"
              >
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
              </svg>
            )}
          </button>
          </div>
          {quotaUsageErrorMsg &&
            <div className='text-center text-sm text-red-900 mt-2'>
              {quotaUsageErrorMsg}
            </div>
          }
        </>
      }
    </form>
  )
}

export default MessageInput
